import React, { useState, useEffect } from 'react';

const IOSInstallPrompt = () => {
  const [showInstallMessage, setShowInstallMessage] = useState(false);
  
  useEffect(() => {
    // Check if this is iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    // Check if already in standalone mode (installed)
    const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || 
                              window.navigator.standalone === true;
    
    // Only show the install message if on iOS and not already installed
    if (isIOS && !isInStandaloneMode) {
      setShowInstallMessage(true);
    }
  }, []);
  
  if (!showInstallMessage) {
    return null;
  }
  
  return (
    <div style={{
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      backgroundColor: '#f8f9fa',
      padding: '10px',
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
      textAlign: 'center',
      fontSize: '14px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <p style={{ margin: '0 0 8px 0' }}>
        Install this app on your iPhone:
      </p>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <span style={{ marginRight: '8px' }}>Tap</span>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 8L12 14L6 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" transform="rotate(90 12 12)"/>
        </svg>
        <span style={{ marginLeft: '8px' }}>then "Add to Home Screen"</span>
      </div>
      <button 
        onClick={() => setShowInstallMessage(false)}
        style={{
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          padding: '6px 12px',
          fontSize: '12px',
          cursor: 'pointer'
        }}
      >
        Dismiss
      </button>
    </div>
  );
};

export default IOSInstallPrompt;
